import HttpService from "@/services/HttpService";

export function globalSearch({ q, modules = null, perPage = 5, page = 1 }) {
  const payload = { q, per_page: perPage, page };
  if (modules) payload.modules = modules;
  return HttpService.post("/global-search", payload);
}
